import React, { createContext, useContext, useState } from 'react';
import moment from 'moment-timezone';

import { accessTokenRequest, sendRequest } from '../global/global.service';
import { urlConfig } from '../../config/urlConfig';
import { AuthenticationContext } from '../authentication/authentication.context';

export const PreferTimeContext = createContext();

const local_time_zone = moment.tz.guess();

const elementSelected =
  'MuiTableCell-root MuiTableCell-body cube selected MuiTableCell-sizeSmall';

export const PreferTimeContextProvider = ({ children }) => {
  const [preferTime, setPreferTime] = useState(null);
  const [timeZone, setTimeZone] = useState(null);
  const [refreshing, setRefreshing] = useState(false);

  const [isLoading, setIsloading] = useState(false);
  const [message, setMessage] = useState('');
  const [toggleSnackBar, setToggleSnackBar] = useState(false);
  const [error, setError] = useState('');
  const { setUserPreferTime } = useContext(
    AuthenticationContext
  );

  const changeTimeZone = (value) => {
    setTimeZone(value);
  };

  const getPreferTime = (refreshing) => {
    if (refreshing) {
      setRefreshing(true);
    }
    setError('');
    accessTokenRequest()
      .then((response) => {
        sendRequest(urlConfig.time_algorithm_url, response, 'get', null)
          .then((res) => {
            setPreferTime(res.data);
            setUserPreferTime(res.data);
            res.data.user_timezone && setTimeZone(res.data.user_timezone);
            setIsloading(false);
            setRefreshing(false);
          })
          .catch((err) => {
            setIsloading(false);
            setRefreshing(false);
            setError(err.toString());
          });
      })
      .catch((err) => {
        setIsloading(false);
        setRefreshing(false);
        setError(err.toString());
      });
  };

  const savePreferTime = () => {
    let data = {
      sun: preferTime ? preferTime.sun : [],
      mon: preferTime ? preferTime.mon : [],
      tue: preferTime ? preferTime.tue : [],
      wed: preferTime ? preferTime.wed : [],
      thu: preferTime ? preferTime.thu : [],
      fri: preferTime ? preferTime.fri : [],
      sat: preferTime ? preferTime.sat : [],
      user_timezone: timeZone ? timeZone : local_time_zone,
    };
    setIsloading(true);
    setError('');
    accessTokenRequest()
      .then((response) => {
        sendRequest(urlConfig.time_algorithm_url, response, 'post', data)
          .then((res) => {
            setPreferTime(res.data);
            setUserPreferTime(res.data);
            setMessage('Saved', res);
            setIsloading(false);
            setToggleSnackBar(true);
          })
          .catch((err) => {
            setError(err.toString());
            setToggleSnackBar(false);
            setMessage(`save prefer time err: ${err}`);
            setIsloading(false);
          });
      })
      .catch((err) => {
        console.log('prefer time token err: ', err);
        setIsloading(false);
        setError(err.toString());
      });
  };

  const isExist = (d, h) => {
    return preferTime[d].includes(parseInt(h, 10));
  };

  const onSelectEnd = (e) => {
    const index = (item) => {
      return (
        preferTime &&
        preferTime[item.id].indexOf(parseInt(item.getAttribute('hour')))
      );
    };
    e.afterAdded.forEach((item) => {
      item.classList.add('selected');
      // prevent push duplicate value
      if (index(item) === -1) {
        preferTime &&
          preferTime[item.id].push(parseInt(item.getAttribute('hour')));
      }
    });

    e.afterRemoved.forEach((item) => {
      item.classList.remove('selected');
      preferTime && preferTime[item.id].splice(index(item), 1);
    });

    e.selected.map((item) => {
      if (item.className === elementSelected) {
        preferTime && preferTime[item.id].splice(index(item), 1);
        item.classList.remove('selected');
      }
      return false;
    });
  };

  const clearPreferTime = () => {
    setUserPreferTime({
      sun: [],
      mon: [],
      tue: [],
      wed: [],
      thu: [],
      fri: [],
      sat: [],
      user_timezone: timeZone ? timeZone : local_time_zone,
    });
    setPreferTime({
      sun: [],
      mon: [],
      tue: [],
      wed: [],
      thu: [],
      fri: [],
      sat: [],
      user_timezone: timeZone ? timeZone : local_time_zone,
    });
  };

  const states = {
    timeZone,
    preferTime,
    toggleSnackBar,
    message,
    isLoading,
    refreshing,
    error,
    setPreferTime,
    setToggleSnackBar,
  };

  const functions = {
    getPreferTime,
    savePreferTime,
    isExist,
    changeTimeZone,
    onSelectEnd,
    clearPreferTime,
  };

  return (
    <PreferTimeContext.Provider
      value={{
        states,
        functions,
      }}
    >
      {children}
    </PreferTimeContext.Provider>
  );
};
